import React, { useState } from 'react'
import Modal from '../modal/modal'
import Input from '../forms/input/input'
import Button from '../button/button'

const ConfirmPhoneModal = ({ onApply, onClose,phone }) => {
  const [detail, setDetail] = useState('')
  return (
    <Modal onClose={onClose} title='确认手机号'>
      <div style={{fontSize:'0.9rem',lineHeight:'1.5rem',marginBottom:'20px'}}>请确认手机号无误，如果输入的手机号码错误，可能会导致未来您的账号被其他人认领</div>
      <Input
        placeholder='请再次确认手机号'
        onChange={v => { setDetail(v) }}
        defaultValue={detail}
        autoFocus={true}
        maxLength={12}
        verify={v => {
            if (!v.length) {
                throw new Error('请输入手机号');
            } else if (!v.startsWith('1') || v.length > 12) {
                throw new Error('手机号格式不正确');
            }else if(v!==phone){
                throw new Error('两次输入手机号不一致，请重新输入');
            }
            return true;
        }}
      />
      <div style={{ textAlign: 'center' }}>
        <Button
          theme={'submit'}
          label={window.L('teach.button.submit')}
          onClick={() => {
            onApply(detail)
          }}
        />
      </div>
    </Modal>
  )
}

export default ConfirmPhoneModal
